import React from 'react';

const Header = () => {
  const handleDaznRedirect = (e) => {
    e.preventDefault();
    window.location.href = 'https://www.dazn.com/en-IN/welcome/en-IN/welcome';
  };

  return (
    <header>
      <div className="header-left">
        <div className="logo-container">
          <img src={`${process.env.PUBLIC_URL}/stream-sports-logo.png`} alt="StreamSportsNow Logo" />
        </div>
        
        <nav>
          <a href="#boxing" onClick={handleDaznRedirect}>Boxing</a>
          <a href="#mma" onClick={handleDaznRedirect}>MMA</a>
          <a href="#kickboxing" onClick={handleDaznRedirect}>Kickboxing</a>
          <a href="#uefa" onClick={handleDaznRedirect}>Soccer / UEFA</a>
          <a href="#womens-football" onClick={handleDaznRedirect}>Women's Football</a>
          <a href="#xgames" onClick={handleDaznRedirect}>X Games</a>
          <a href="#esports" onClick={handleDaznRedirect}>Esports</a>
          <a href="#fishing" onClick={handleDaznRedirect}>Fishing</a>
          <a href="#us-sports" onClick={handleDaznRedirect}>US Sports News</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
